import React, {useState} from 'react';
import { DataTable } from 'primereact/datatable';
import {Column} from "primereact/column";
import {Checkbox} from "primereact/checkbox";
import { useMyMessageList } from '../../hooks/taskHooks';
import statuses from 'data/task-question-status.json';
import { Tag } from 'primereact/tag';

import {useSelector} from "react-redux";
import MessageCenterTableRowAction from './message-center/MessageCenterTableRowAction';

/**
 *
 * @param {*} param0
 * @returns
 */
const MessageCenterTable = (props) => {
    const [showOpenedOnly, setShowOpenedOnly] = useState(true);
    const [showDirectReporteeOnly, setShowDirectReporteeOnly] = useState(false);
    const isOutbox = (props?.type ?? "").toLowerCase().trim()  === "outbox";

    const selectedYear = useSelector(state => state.kpi.selectedYear);

    const messageList = useMyMessageList({showOpenedOnly, showDirectReporteeOnly, isOutbox, deadlineYear: selectedYear});

    const buildHeader = () => {
        return (
            <div className="table-header">
                    <div>
                        <div className="show-completed-tasks mb-3" style={{ width: '100%' }}>
                            <Checkbox inputId="show-completed" checked={showOpenedOnly} onChange={e => setShowOpenedOnly(e.checked)} />
                            <label htmlFor="show-completed">Show Unresolved Only</label>
                            {!isOutbox && <> 
                                <Checkbox inputId="show-direct" className="ml-5" checked={showDirectReporteeOnly} onChange={e => setShowDirectReporteeOnly(e.checked)} />
                                <label htmlFor="show-direct">From Direct Reportee's Only</label>
                            </>}
                        </div>
                    </div>
            </div>
        );
    };


    const statusColumn = (row) => {
        const status = statuses.find(e => e.code === row.status);
        return <Tag value={status?.text} severity={status?.severity}></Tag>;
    };

    const taskColumn = (row) => {
        return row.task?.name + 
            (!isOutbox? " (" + (((row.questionBy.firstName ?? '') + " " + (row.questionBy.lastName ?? '')).trim() || row.questionBy.email) + ")" : "")
                    + " - " + row.task?.taskType;
    };

    const deadlineColumn = (row) => {
        return (row.deadline? new Date(row.deadline) : new Date()).toLocaleDateString();
    };


    const createdAtColumn = (row) => {
        return (row.createdAt? new Date(row.createdAt) : new Date()).toLocaleDateString();
    };
    

    const descriptionColumn = (row) => {
        return row.status === 'UNREAD' ? <div><span style={{color: "red"}}>&bull;</span> {row.text}</div> : row.text;
    };

   


    return (
        <div className="mobile-horizontal-scrollable">
            {buildHeader()}
            <DataTable value={messageList} dataKey="id" tableStyle={{ width: '100%' }}>
                <Column field="text" header="Description" body={descriptionColumn}/>
                <Column field="status" header="Status" body={statusColumn}   />
                <Column field="taskName" header="Task" body={taskColumn}   />
                <Column field="createdAt" header="Created at" body={createdAtColumn}   />
                <Column field="deadline" header="Due date" body={deadlineColumn}   />
                <Column field="" header="Actions" body={(row) => MessageCenterTableRowAction({isOutbox, row})} />
            </DataTable>
        </div>
    )
}

export default MessageCenterTable;
